<template>
		<b-form-input
		type="text"
		v-model="formattedDate"
		autocomplete="off"
		:size="getSize"
		@keypress="dateMask($event)"
		@blur="checkDate()"
		maxlength="10"
		:required="required"
		v-on="$listeners"
		v-bind="$attrs"
		/>
</template>

<script>
import moment from 'moment';
export default {
	props: {
		value: String,
		required: Boolean,
		size: String
	},
	data(){
		return {
			date: null
		}
	},
	computed: {
		formattedDate: {
				get() {return this.value},
				set(formattedDate) {this.setLocalValue(formattedDate);}
		},
		//propriedade necessaria para resolver o problema de mutating prop e evitar a alteracao da prop pelo componente filho
		getSize() {
				if(this.size)
						return this.size;
				return "sm"
		}
	},
	methods:{
		parseDate(stringDate){
			var momentDate = moment(stringDate, 'DD/MM/YYYY');
			this.date = momentDate.toDate();
		},
		formatDate(){
			if(this.date){
				var momentDate = moment(this.date);
				this.formattedDate = momentDate.format("DD/MM/YYYY");
			}
			else this.formattedDate = null;
		},
		checkDate(){
			this.parseDate(this.formattedDate);
			if(isNaN(this.date)){
				this.date = null;
				this.formattedDate = "";
			}
		},
		dateMask(e){
			var len = this.formattedDate.length;
			var barQty = this.formattedDate.split("/").length - 1;
			if((e.key < "0" || e.key > "9") && e.key != "/") e.preventDefault();
			if(e.key == "/" && (len < 6 || barQty == 2)) e.preventDefault();
			if(len === 2 || len === 5) this.formattedDate += '/';
		},
		//metodo necessario para resolver o problema de mutating prop e evitar a alteracao da prop pelo componente filho
		setLocalValue(newValue) {
			this.$emit('input', newValue);
		}
	},
	watch: {
		date(){
			this.formatDate();
		}
	}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/shared/BlumarDateInput.vue